// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__YUYOi","mobileGif":"styles_mobileGif__GHFCd","overlay":"styles_overlay__JfSz9","bannerTitle":"styles_bannerTitle__5agHc"};